export const fetched_four_movies = "fetched_four_movies";
export const set_questions = "set_questions";
export const set_shuffled_questions = "set_shuffled_questions";
export const reset_question_store = "reset_question_store";
